import { ModuleId, resolveEnabledModules } from "@cerberus/modules";
import { getActiveBrand } from "../branding/activeBrand";
import { getRunConfig } from "../config/runtimeConfig";
import { ALL_MANIFESTS } from "./registry";
import { PluginManifest } from "./types";

// The enabled-module set is fixed for the lifetime of the deployment (derived from
// the brand + optional `window.runConfig.modules` override), so it's safe to read
// without React. The ModulesProvider exposes the same values to components.

export function getEnabledModuleIds(): ModuleId[] {
  // import.meta.env.DEV: the Vite dev server only, never a built bundle — development-only
  // modules (the questionnaire builder) are local-only by construction.
  return resolveEnabledModules(getActiveBrand().key, getRunConfig().modules, import.meta.env.DEV);
}

export function isModuleEnabled(id: ModuleId): boolean {
  return getEnabledModuleIds().includes(id);
}

export function getEnabledManifests(): PluginManifest[] {
  const enabled = new Set<ModuleId>(getEnabledModuleIds());
  return ALL_MANIFESTS.filter((m) => enabled.has(m.id));
}
